






















import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PromotionActivityApi from '@/api/marketing/promotionActivity/index'
import PromotionProductApi from '@/api/marketing/promotionProduct/index'
import GoodSelect from '@/components/goods-select/index.vue'
@Component({
  components: {
    GoodSelect,
  },
})
export default class PromotionProductManager extends AbpBase {
  @Prop({ type: String, default: '' }) id: string
  @Prop({ type: String, default: '' }) promotionType: string
  columns1 = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '商品名称',
      width: 450,
      key: 'productName',
      align: 'center',
    },
    {
      title: '货号',
      key: 'productCode',
      align: 'center',
    },
    {
      title: '市场价',
      key: 'marketPrice',
      align: 'center',
    },
    {
      renderHeader: (h, params) => {
        let title
        if (this.promotionType === 'preSales') {
          title = '预售价'
        } else {
          title = '零售价'
        }
        return h('span', {}, [title])
      },
      render: (h, params) => {
        var d = this.getData()
        if (this.promotionType !== 'preSales') {
          return h('span', {}, [d[params.index].price])
        }

        return h('InputNumber', {
          props: {
            value: d[params.index].price,
            min: 0,
          },
          on: {
            'on-change': (event: number) => {
              d[params.index].price = event
            },
          },
        })
      },
      key: 'price',
      width: 120,
      align: 'center',
    },
    {
      renderHeader: (h, params) => {
        let title
        switch (this.promotionType) {
          case 'preSales':
            title = '预售定金'
            break
          case 'group':
            title = '拼团价'
            break
          case 'secKill':
            title = '秒杀价'
            break
          case 'bargain':
            title = '底价'
            break
          case 'limitRewardPointExchange':
            title = '兑换价'
            break
          default:
            title = '活动价'
            break
        }
        return h('span', {}, [title])
      },
      render: (h, params) => {
        var d = this.getData()
        return h('InputNumber', {
          props: {
            value: d[params.index].promotionPrice,
            min: 0,
          },
          on: {
            'on-change': (event: number) => {
              d[params.index].promotionPrice = event
            },
          },
        })
      },
      align: 'center',
    },
    {
      title: '操作',
      width: 100,
      slot: 'action',
    },
  ]
  getData() {
    return this.data1
  }
  data1: {
    productId: string
    pictureUrl: string
    productName: string
    brandName: string
    productCode: string
    marketPrice: number
    price: number
    promotionPrice: number
    limit: number
    displayOrder: number
  }[] = []
  created() {
    if(this.promotionType === 'limitDiscount' || this.promotionType === 'tierDiscount'){
        this.columns1.splice(5, 1)
    }
    this.loadData()
  }
  loadData() {
    PromotionProductApi.getList(10, 1, this.id, '', '').then((res) => {
      console.log(res)
      this.data1 = res.data.items
    })
  }
  remove(index) {
    this.data1.splice(index, 1)
  }
  onChange(e) {
    console.log('e: ', e)
    this.data1 = this.data1.concat(
      e.map((x) => {
        return {
          productId: x.id,
          pictureUrl: x.pictureUrl,
          productName: x.name,
          brandName: x.brandName,
          productCode: x.code,
          marketPrice: x.marketPrice,
          price: x.price,
          promotionPrice: x.promotionPrice || x.price,
          limit: 0,
          displayOrder: 0,
        }
      })
    )
  }
  save() {
    PromotionProductApi.addProductToPromotionActivity(this.id, this.data1).then(
      (res) => {
        this.$Message.success('保存成功')
      }
    )
  }
}
